module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title0",
    attrs: {
      "id": "ch-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("The Supreme Court’s Assault on Free Exercise, and the Amicus Brief That Was Never Filed")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('h1', {
    staticClass: "sec10",
    attrs: {
      "id": "sec-5"
    }
  }, [_c('em', [_vm._v("8 Journal of Law and Religion 99 (1990)")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("This short article reprints my initial response to")]), _vm._v(" Employment Division v. Smith "), _c('em', [_vm._v("(1990). The article adds a short prologue and postscript to an amicus brief in support of the unsuccessful petition for rehearing. Petitions for rehearing are due fourteen days after the Court’s decision, and we circulated a draft for signature, so the amicus brief was written immediately after the Court’s decision. It is short, punchy, and pointed. For reasons explained in the prologue, the amicus brief was never filed.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-15"
    }
  }, [_c('strong', [_vm._v("Prologue")])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("On April 17, 1990, in "), _c('em', [_vm._v("Employment Division v. Smith,")])]), _c('a', {
    attrs: {
      "href": "#/#foot-1",
      "id": "foot_1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" the Supreme Court decided that neutral laws of general applicability may be applied to restrict or forbid religious exercise, and that such applications raise no issue under the Free Exercise Clause. The opinion removes many of the issues discussed in this journal from the scope of positive constitutional law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court noted some exceptions. Whether anything remains of free exercise depends on future cases interpreting those exceptions and interpreting the Court’s requirement that laws regulating religion be neutral. The Court recognized constitutional protection for religious speech and religious instruction of children, and if interpreted generously, those exceptions could protect a large proportion of religious conduct. If the exceptions and the neutrality requirement are interpreted narrowly, the Free Exercise Clause has little independent content.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("A large group of law professors signed the appellees’ unsuccessful petition for rehearing.")]), _c('a', {
    attrs: {
      "href": "#/#foot-2",
      "id": "foot_2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" In addition, a large coalition of religious and civil liberties organizations joined in the petition."), _c('a', {
    attrs: {
      "href": "#/#foot-3",
      "id": "foot_3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" That coalition had planned to file a brief amicus curiae. I had already written the brief and sent it to the printer when we discovered that the 1990 amendments to the Supreme Court’s rules expressly preclude amicus briefs on petitions for rehearing. The new rule changed the Court’s prior practice,"), _c('a', {
    attrs: {
      "href": "#/#foot-4",
      "id": "foot_4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" and it had not yet been generally published.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("When the Guest Editor asked me to write something about "), _c('em', [_vm._v("Smith")]), _vm._v(", I offered the unfiled amicus brief. It is an authentic early reaction to "), _c('em', [_vm._v("Smith")]), _vm._v(", it highlights the dangers of the Court’s decision, and in the short time available, I did not have time to write an article.")]), _c('a', {
    attrs: {
      "href": "#/#foot-5",
      "id": "foot_5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" The brief takes a pessimistic view of the opinion, emphasizing the consequences of a narrow interpretation of the exceptions and of the neutrality requirement, in hopes of steering the Court to a broader interpretation. The Argument from the brief is printed without substantive change, but citations have been moved to footnotes to conform to law review style. A postscript following the brief describes pending efforts to cure "), _c('em', [_vm._v("Smith")]), _vm._v(" by statute.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-16"
    }
  }, [_c('strong', [_c('em', [_vm._v("Brief Amicus Curiae")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-17"
    }
  }, [_c('strong', [_vm._v("Question Presented")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Whether the Court should permit briefing and argument before deciding that religious practice is entitled to no constitutional protection whatever against facially neutral regulation.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-18"
    }
  }, [_c('strong', [_vm._v("Reasons for Granting Rehearing")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-7"
    }
  }, [_c('strong', [_c('em', [_vm._v("I. A Decision of This Magnitude Deserves to Be Briefed and Argued.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Amici of course understand that rehearing is an extraordinary procedure. We do not urge it lightly. But what is formally a rehearing in this case would in fact be the first hearing on an issue of momentous importance. Respondents are entitled to be heard on the issue the Court decided.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The opinion in this case holds that religiously motivated conduct can be criminally punished pursuant to facially neutral legislation, without a compelling state interest, and perhaps without any justification at all. If the statute has a rational basis as applied to secular conduct, it appears that the state need not show any reason for refusing to exempt sincere religious practice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("This issue was not presented by the facts of the case, which involved no threat of criminal prosecution. The issue was not briefed by the parties. No one asked the Court to take this extraordinary step. Had anyone known the Court was considering this issue, the parties and many amici would have brought much analysis and information to the Court’s attention. Respondents had no opportunity to brief the issue, and potential amici had no reason to suppose that this was other than the narrow and fact-specific case it appeared to be.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("On other occasions when the Court has decided to consider a new issue, broader than the issues raised by the parties, it has announced its intention and invited reargument.")]), _c('a', {
    attrs: {
      "href": "#/#foot-6",
      "id": "foot_6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" In some of these cases, full argument persuaded the Court not to take the step it had been considering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Notice and argument is the proper procedure. It is the only procedure consistent with due process to the parties, and it is the only procedure consistent with this Court’s responsibility for deciding cases of broad public importance selected from the pool of petitions for certiorari.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The public importance of this case is attested by the extraordinary diversity of the amici joining in this brief. These amici agree on very little, but they agree that religion cannot be free without some constitutional protection for religious practice in a secular world. These amici wish the Court to understand the decision’s full impact on religious organizations. Because a decision of this magnitude deserves to be briefed and argued, these amici urge the Court to grant respondent’s Petition for Rehearing and restore the case to the argument docket.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-8"
    }
  }, [_c('strong', [_c('em', [_vm._v("II. Full Briefing and Argument Would Reveal Many Reasons for Believing That the Court’s Opinion May Be in Error.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("There are many reasons for believing that the Court’s opinion may be in error. The opinion appears to be inconsistent with the original intent, inconsistent with the constitutional text, inconsistent with doctrine under other constitutional clauses, and inconsistent with precedent. It strips the Free Exercise Clause of independent meaning. Reasonable development of these points requires full briefing, but we introduce them here to indicate the potential benefits of reargument.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec5-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('strong', [_c('em', [_vm._v("A. Original Intent.")])])])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("The opinion is inconsistent with original intent. The Court had no way to know of exhaustive new scholarship on the original meaning of the Free Exercise Clause. In an article published shortly after the Court’s opinion, Professor Michael McConnell shows that legislatures in the founding generation considered exemptions from facially neutral laws to be part of the free exercise of religion,")]), _c('a', {
    attrs: {
      "href": "#/#foot-7",
      "id": "foot_7"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" and that the new institution of judicial review made this right to free exercise judicially enforceable."), _c('a', {
    attrs: {
      "href": "#/#foot-8",
      "id": "foot_8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" State free exercise clauses included exceptions for conduct threatening “peace and safety” — exceptions that would not have been necessary if the clauses were not understood to protect conduct."), _c('a', {
    attrs: {
      "href": "#/#foot-9",
      "id": "foot_9"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Exemptions were necessary because, in the language of James Madison in the "), _c('em', [_vm._v("Memorial and Remonstrance Against Religious Assessments")]), _vm._v(", “Man’s duty to his Creator is precedent both in order of time and degree of obligation, to the claims of Civil Society.”"), _c('a', {
    attrs: {
      "href": "#/#foot-10",
      "id": "foot_10"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" Many Americans held this view, especially the evangelicals who were the primary political force demanding the Free Exercise Clause."), _c('a', {
    attrs: {
      "href": "#/#foot-11",
      "id": "foot_11"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" Exceptions were of course necessary — peace and safety in their language, compelling interest in ours — but the primacy of conscience was the starting presumption. Protections that were necessary in the Founders’ limited state are far more necessary today.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec5-13"
    }
  }, [_c('strong', [_c('em', [_vm._v("B. Constitutional Text.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The opinion is inconsistent with the constitutional text. The opinion acknowledges that religiously motivated conduct is the “exercise of religion,”"), _c('a', {
    attrs: {
      "href": "#/#foot-12",
      "id": "foot_12"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" and that such conduct is prohibited by Oregon law. We do not understand how this prohibiting of the exercise of religion is not “prohibiting the free exercise of religion.”"), _c('a', {
    attrs: {
      "href": "#/#foot-13",
      "id": "foot_13"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The press cases cited in support of the Court’s reading are not in point. Those cases hold that the commercial aspects of large media corporations do not escape all regulation and taxation simply because their end product is "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("communication.")]), _c('a', {
    attrs: {
      "href": "#/#foot-14",
      "id": "foot_14"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" These cases do not hold that facially neutral laws restricting speech or press raise no issue under the Speech and Press Clauses. In fact the Court has held the opposite, as the next subsection shows.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec5-14"
    }
  }, [_c('strong', [_c('em', [_vm._v("C. Doctrine Under Other Constitutional Clauses.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The decision in this case is inconsistent with doctrine under other constitutional clauses. First Amendment rights frequently require exceptions from facially neutral laws. Unpopular political parties and movements have been exempted from facially neutral disclosure laws."), _c('a', {
    attrs: {
      "href": "#/#foot-15",
      "id": "foot_15"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" Just two years ago, the Court unanimously created special defenses to protect the press from the facially neutral tort of intentional infliction of emotional distress."), _c('a', {
    attrs: {
      "href": "#/#foot-16",
      "id": "foot_16"
    }
  }, [_c('sup', [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The opinion is also inconsistent with the speech cases in another way. The Court says that it cannot apply the compelling interest test to free exercise cases without weighing the burden imposed on religious exercise."), _c('a', {
    attrs: {
      "href": "#/#foot-17",
      "id": "foot_17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" The Court then says that such balancing would be inappropriate, just as it would be inappropriate “to determine the ‘importance’ of ideas before applying the ‘compelling interest’ test in the free speech field.”"), _c('a', {
    attrs: {
      "href": "#/#foot-18",
      "id": "foot_18"
    }
  }, [_c('sup', [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But of course the Court regularly considers the importance of different kinds of speech. It holds that political speech is more important than commercial speech, that criticism of public figures is more important than criticism of private figures, that pornography is of limited value and obscenity is of no value, and that some speech is not of public concern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The day after this case, the Court routinely balanced the “exceedingly modest” interest in possessing child pornography against the state’s compelling interest in preventing “the exploitative use of children.”"), _c('a', {
    attrs: {
      "href": "#/#foot-19",
      "id": "foot_19"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" Four of the five justices in the majority in this case joined "), _c('em', [_vm._v("Osborne.")]), _vm._v(" The fifth member of the majority has written similar balancing opinions in the past."), _c('a', {
    attrs: {
      "href": "#/#foot-20",
      "id": "foot_20"
    }
  }, [_c('sup', [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("The Court has never held that all restrictions on speech require equal justification. The Court is no more obliged to hold that all burdens on religious exercise require equal justification. Full briefing would show that the centrality dilemma that troubled the Court is soluble. It is true that courts must consider the magnitude of the burden on religion as well as the magnitude of the government’s interest. But it is not true that courts must make a threshold determination of centrality, categorizing all religious practices as central or non-central. What the compelling interest test requires is that the government interest in regulating religion compellingly outweigh the resulting burden on religion, whatever the magnitude of that burden.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec5-15"
    }
  }, [_c('strong', [_c('em', [_vm._v("D. Precedent.")])])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("The opinion is inconsistent with precedent. The Petition for Rehearing demonstrates that literally no one, including the Justices in the majority, had previously understood this Court’s precedents as the opinion now interprets them. The relevant law in this case dates from "), _c('em', [_vm._v("Sherbert v. Verner")])]), _c('a', {
    attrs: {
      "href": "#/#foot-21",
      "id": "foot_21"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" in 1963. But nearly all the Court’s quotations come from cases decided earlier, or from separate opinions of one to three Justices written since. The Court repeatedly quotes "), _c('em', [_vm._v("Minersville School District v. Gobitis.")]), _c('a', {
    attrs: {
      "href": "#/#foot-22",
      "id": "foot_22"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" But "), _c('em', [_vm._v("Gobitis")]), _vm._v(" triggered a nationwide outburst of violence against Jehovah’s Witnesses,"), _c('a', {
    attrs: {
      "href": "#/#foot-23",
      "id": "foot_23"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" and it was overruled in "), _c('em', [_vm._v("West Virginia Board of Education v. Barnette.")]), _c('a', {
    attrs: {
      "href": "#/#foot-24",
      "id": "foot_24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" Until the opinion in this case, "), _c('em', [_vm._v("Gobitis")]), _vm._v(" was thoroughly discredited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court quotes the three-justice plurality opinion in "), _c('em', [_vm._v("Bowen v. Roy.")]), _c('a', {
    attrs: {
      "href": "#/#foot-25",
      "id": "foot_25"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" But five Justices rejected that opinion in separate opinions at the time, and the Court specifically repudiated it in "), _c('em', [_vm._v("Hobbie v. Unemployment Appeals Comm’n of Florida.")]), _c('a', {
    attrs: {
      "href": "#/#foot-26",
      "id": "foot_26"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" The Court quotes Justice Stevens’ separate opinion in "), _c('em', [_vm._v("United States v. Lee.")]), _c('a', {
    attrs: {
      "href": "#/#foot-27",
      "id": "foot_27"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" But a separate opinion by one Justice is obviously not an opinion of the Court. Not a single majority opinion since "), _c('em', [_vm._v("Sherbert")]), _vm._v(" states the rule that the Court extracts from its cases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The opinion in this case recharacterizes "), _c('em', [_vm._v("Wisconsin v. Yoder,")]), _c('a', {
    attrs: {
      "href": "#/#foot-28",
      "id": "foot_28"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" which twice "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("went out of its way to emphasize that the result turned on the religious basis of Amish beliefs, and that Henry Thoreau or a secular commune would not get similar protection. The Court said that “Thoreau’s choice was philosophical and personal rather than religious, and such belief does not rise to the demands of the Religion Clauses.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-29",
      "id": "foot_29"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" And: “It cannot be overemphasized that we are not dealing with a way of life and mode of education by a group claiming to have recently discovered some ‘progressive’ or more enlightened process for rearing children in modern life.”"), _c('a', {
    attrs: {
      "href": "#/#foot-30",
      "id": "foot_30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" Compare another recent opinion, citing "), _c('em', [_vm._v("Yoder")]), _vm._v(" for the proposition that “intentional government advancement of religion is sometimes required by the Free Exercise Clause.”"), _c('a', {
    attrs: {
      "href": "#/#foot-31",
      "id": "foot_31"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" We do not believe that "), _c('em', [_vm._v("Yoder")]), _vm._v(" requires government to advance religion, but we do agree that "), _c('em', [_vm._v("Yoder")]), _vm._v(" was unambiguously a free exercise case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The opinion recharacterizes "), _c('em', [_vm._v("Lyng v. Northwest Indian Cemetery Protective Association,")]), _c('a', {
    attrs: {
      "href": "#/#foot-32",
      "id": "foot_32"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" over the objections of its author, and recharacterizes the majority holding in "), _c('em', [_vm._v("Bowen v. Roy,")]), _c('a', {
    attrs: {
      "href": "#/#foot-33",
      "id": "foot_33"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" that the government could use plaintiff’s social security number in its own internal records. Both of those cases were decided on the ground that the government had not required plaintiffs to act or refrain from acting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The opinion reduces the unemployment compensation cases to an isolated exception of uncertain scope and principle. If they are merely unemployment compensation cases, this is an unemployment compensation case. If they are now cases about religious gerrymandering, respondents should have an opportunity to show that this case involves a religious gerrymander. Without tacit exemptions, the practice of First Communion would be a crime in every state. But it is unlikely that Oregon would enforce its alcohol laws against the use of communion wine by under-age Catholics. If the unemployment cases are about statutes with individualized hearings, a criminal trial is the most elaborate individualized hearing known to the law, and the issue of religious motivation is readily assimilated to the issue of mens rea. Whatever the rationale of the unemployment compensation exception, it is not clear why that exception does not apply to this case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Finally, the opinion says that some opinions merely “purported” to do what they said they were doing."), _c('a', {
    attrs: {
      "href": "#/#foot-34",
      "id": "foot_34"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" When earlier opinions must be characterized "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("as “purported,” precedent is being overruled and the Court should hear argument on the proposed overruling.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("In fact, the Court has declined to apply the compelling interest test on only three occasions since "), _c('em', [_vm._v("Sherbert:")]), _vm._v(" in "), _c('em', [_vm._v("Goldman v. Weinberger,")])]), _c('a', {
    attrs: {
      "href": "#/#foot-35",
      "id": "foot_35"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" involving a plaintiff subject to military discipline, in "), _c('em', [_vm._v("O’Lone v. Shabazz,")]), _c('a', {
    attrs: {
      "href": "#/#foot-36",
      "id": "foot_36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" involving prisoners, and in "), _c('em', [_vm._v("Lyng,")]), _c('a', {
    attrs: {
      "href": "#/#foot-37",
      "id": "foot_37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" involving the government’s right to manage its own land. The point of those cases was that there was less than the usual degree of constitutional protection in those contexts. Even prisoners had some right to exemptions; lower courts have ordered Kosher meals instead of facially neutral prison food."), _c('a', {
    attrs: {
      "href": "#/#foot-38",
      "id": "foot_38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" The opinion in this case reduces the religious liberty rights of all Americans to a level less than that previously accorded to imprisoned felons.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec5-16"
    }
  }, [_c('strong', [_c('em', [_vm._v("E. Stripping the Free Exercise Clause of Meaning.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The opinion in this case reduces the Free Exercise Clause to a cautious redundancy, relevant only to “hybrid” cases."), _c('a', {
    attrs: {
      "href": "#/#foot-39",
      "id": "foot_39"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" The opinion appears to say that the Free Exercise Clause merely emphasizes that religious speech is important to the Free Speech Clause, that religious discrimination is important to the Equal Protection Clause, and that religious education is important to the unenumerated right of parents to control their children’s education. But the clause no longer has independent meaning; any violation of free exercise would also be a violation of free speech, equal protection, or parental rights. Leaving a major clause of the Constitution without content is surely a signal that the Court might have made a mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Indeed, the mere statement of the Court’s holding should cause second thoughts. This case holds that criminal punishment of the central religious ritual of an ancient faith raises no issue under the Free Exercise Clause and requires no justification!")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The amici joining in this brief are divided on whether the peyote ritual should be constitutionally protected. Some agree with Justice O’Connor that the state has compelling reason to forbid the peyote ritual; some agree with "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("the dissenters that the ritual is self-regulating and harmless. But all of these amici agree that the issue is whether Oregon has sufficient justification for applying its law to the peyote ritual. All of these amici are astonished at the holding that "), _c('em', [_vm._v("suppression of a worship service raises no issue")]), _vm._v(" under the Free Exercise Clause.")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That understanding of religious liberty is only marginally better than Oliver Cromwell’s, who said to the Catholics of England and Ireland:")])]), _c('p', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("As to freedom of conscience, I meddle with no man’s conscience; but if you mean by that, liberty to say the Mass, I would have you understand that in no place where the power of the Parliament of England prevails will that be permitted.")]), _c('a', {
    attrs: {
      "href": "#/#foot-40",
      "id": "foot_40"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This Court has said to Americans of all faiths that they have a constitutional right to believe their religion but no constitutional right to practice it.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-9"
    }
  }, [_c('strong', [_c('em', [_vm._v("III. The Court’s Opinion Leads to Results in Pending and Recent Cases That Are Inconsistent with Any Plausible Understanding of Free Exercise.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("If the Court means what it said in this case, churches and believers are now subject to all the regulatory burdens of the modern welfare state. Given the largely secular ethos of modern society, facially neutral regulation will produce intolerable burdens on religion. These burdens will fall with special force on traditional religions that do not change their teaching to accommodate every change in social and political mores. We list here a few examples in which the Court’s opinion implausibly suggests that there is no free exercise issue in the case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is no exception for sex discrimination by religious employers in Title VII or in most state or local employment discrimination laws. It now follows that religious schools may be forced to employ unmarried pregnant teachers. See "), _c('em', [_vm._v("Dolter v. Wahlert High School,")]), _c('a', {
    attrs: {
      "href": "#/#foot-41",
      "id": "foot_41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" holding that a Catholic school was constitutionally entitled to enforce its moral standards. See also "), _c('em', [_vm._v("Ohio Civil Rights Commission v. Dayton Christian Schools, Inc.,")]), _c('a', {
    attrs: {
      "href": "#/#foot-42",
      "id": "foot_42"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" involving a charge of sex discrimination against a religious school that believed that mothers of small children should not be working full time for the church or its school. "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("The opinion in this case seems to say that neither of these cases even raised a constitutional issue.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("If employment discrimination laws apply to churches without constitutional limit, there is nothing to prevent some state from ordering the Roman Catholic Church to ordain women. Title VII on its face seems to require that result, and at least one commentator has argued for a literal interpretation.")]), _c('a', {
    attrs: {
      "href": "#/#foot-43",
      "id": "foot_43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" The opinion in this case seems to say that the church would have no constitutional defense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Anti-discrimination laws may also require churches and religious institutions to sponsor, employ, or even ordain practicing homosexuals. See "), _c('em', [_vm._v("Walker v. First Presbyterian Church,")]), _c('a', {
    attrs: {
      "href": "#/#foot-44",
      "id": "foot_44"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" rejecting an attempt to apply the San Francisco gay rights ordinance to employment of a church organist. See also "), _c('em', [_vm._v("Gay Rights Coalition v. Georgetown University,")]), _c('a', {
    attrs: {
      "href": "#/#foot-45",
      "id": "foot_45"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" partially rejecting an attempt to force a Jesuit university to sponsor a student gay rights organization. The opinion in this case appears to say that neither Georgetown nor the Presbyterian church in San Francisco had any constitutional defense. Nor would there be any constitutional defense if San Francisco forced objecting churches to ordain gay priests and bishops, because the core of religious exercise now gets no more protection than the “practice of throwing rice at church weddings.”"), _c('a', {
    attrs: {
      "href": "#/#foot-46",
      "id": "foot_46"
    }
  }, [_c('sup', [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Churches may be forced to submit their sacred architecture, including even altars and liturgical displays, to the control of secular landmark commissions. See "), _c('em', [_vm._v("Society of Jesus v. Boston Landmarks Commission,")]), _c('a', {
    attrs: {
      "href": "#/#foot-47",
      "id": "foot_47"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" holding that such regulation would be unconstitutional.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Students and public employees may be penalized for observing their religious holidays. See "), _c('em', [_vm._v("Church of God v. Amarillo Independent School District,")]), _c('a', {
    attrs: {
      "href": "#/#foot-48",
      "id": "foot_48"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" enforcing such a penalty. An examination on Good Friday or Yom Kippur may mean the difference between passing and failing. The opinion in this case seems to say that the school need not offer a make-up exam and need not offer any reason for its refusal to do so. And this despite the fact that the entire school calendar is designed to accommodate the majority’s observance "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("of Sunday, and gerrymandered to accommodate the majority’s observance of Christmas.")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These examples are not a parade of horribles from an advocate’s imagination. They are based on real cases. They show the dangers of exclusive reliance on the political branches to accommodate religious minorities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is true that legislatures often exempt the practices of religious minorities, especially the “respectable” practices of socially accepted minorities. But these legislative exemptions have often been motivated by the belief that they are constitutionally required. In the experience of these amici, debate at legislative hearings is often focused on this Court’s opinions. If this Court says no exemptions are required, legislatures will enact many fewer exemptions.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("It is also true that legislatures are sometimes captured by fear and hostility to unfamiliar minority faiths. Roman Catholics, Mormons, Jehovah’s Witnesses, and contemporary “cults” have experienced periods of hostility and persecution even in America.")]), _c('a', {
    attrs: {
      "href": "#/#foot-49",
      "id": "foot_49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" It takes little imagination for a legislature so inclined to suppress a minority faith with a facially neutral law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Even with the best of intentions, legislative protection for religious minorities is episodic, uninformed, and unreliable. Legislatures often enact laws without considering or even knowing about their impact on religion. Bureaucrats often enforce these laws with a single-minded focus on their agency’s mission, brooking no exceptions. Powerful forces in modern society resist any accommodation for religious minorities. Religious minorities have little clout in the political process, and they face all the burdens of legislative inertia and crowded calendars in seeking legislative exemptions. If there are no votes in it, a busy legislature may never get around to listening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The only branch of government that was required to listen to the complaints of religious minorities and render an unbiased decision was the judiciary. Now that branch has closed its doors. The inevitable consequence is that some Americans will suffer for conscience, and that others will abandon the practice of their faith to avoid prosecution. These are precisely the results the Free Exercise Clause was intended to avoid.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('strong', [_c('em', [_vm._v("IV. Permitting Such Unrestricted Regulation of Churches Is Not Neutral. It Ensures Burdens on Religion and Discrimination among Religions.")])])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("This Court has repeatedly said that a major goal of the Religion Clauses is neutrality toward religion. Government should neither encourage nor discourage religion; it should neither subsidize nor burden religion; it should neither advance nor inhibit religion.")]), _c('a', {
    attrs: {
      "href": "#/#foot-50",
      "id": "foot_50"
    }
  }, [_c('sup', [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mere facial neutrality cannot achieve these goals. Modern government encourages, discourages, subsidizes, and burdens a vast range of activities. Facial neutrality will subject religion to the same range of subsidies and burdens. If government is to avoid encouraging or discouraging religion, then it must often exempt religion from the subsidies and burdens applied to secular activity."), _c('a', {
    attrs: {
      "href": "#/#foot-51",
      "id": "foot_51"
    }
  }, [_c('sup', [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Criminal punishment of religious exercise obviously has a powerful tendency to discourage religion. But in many cases, an exemption for conscientious objectors has little or no tendency to encourage religion. Letting the church control its own altar, or refuse to hire homosexual organists, will not attract anyone not already attracted. Much religious practice is self-restraining, personally burdensome, or meaningless to non-believers. Unlike criminal prosecutions, exemptions neither encourage nor discourage religion. The simple truth is that people with a deeply held conscientious objection to a law are not similarly situated to people without such an objection. In a wide range of cases, exemption for conscientious objectors is the most neutral course available."), _c('a', {
    attrs: {
      "href": "#/#foot-52",
      "id": "foot_52"
    }
  }, [_c('sup', [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The opinion in this case acknowledges that its decision “will place at a relative disadvantage those religious practices that are not widely engaged in.”"), _c('a', {
    attrs: {
      "href": "#/#foot-53",
      "id": "foot_53"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" Put more bluntly, this means that churches without political clout may be suppressed by facially neutral restrictions on practices important only to them, and that more powerful churches may be accommodated. If the Court is unwilling to protect religious minorities, the constitutional goal of neutrality "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("among religions is unachievable, and the Court’s traditional role of protecting religious and other minorities")]), _c('a', {
    attrs: {
      "href": "#/#foot-54",
      "id": "foot_54"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" is in serious doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Four of the five justices in the majority recently expressed the fear that the Court’s interpretation of the Establishment Clause “reflects an unjustified hostility toward religion, a hostility inconsistent with our history and our precedents.”"), _c('a', {
    attrs: {
      "href": "#/#foot-55",
      "id": "foot_55"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" As on so many issues, these amici disagree about the merits of that criticism in the Establishment Clause context. And we do not suggest that the majority was motivated by hostility to religion even in its evisceration of the Free Exercise Clause. But hostility will be the result.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Judicial enforcement of the Establishment Clause, combined with judicial abdication on the Free Exercise Clause — especially in a society in which every religion is a minority and the forces of secularization are strong — will gradually lead to a pervasive governmental hostility to religion. The ebb and flow of the political process will throw up both burdens and benefits to religion. If all the benefits are struck down, and all the burdens are upheld, the cumulative effect will be a severe burden on religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court cannot restore neutrality by abdicating on the Establishment Clause as well. That would allow transient political majorities to treat religion as they will, without regard to the needs of minorities of believers or of nonbelievers. The only solution is for this Court to enforce both Religion Clauses. At the very least, the Free Exercise Clause should preclude a regime in which government can send men and women to jail for practicing their faith and never be asked to state its reasons for the law that sent them there.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-11"
    }
  }, [_c('strong', [_c('em', [_vm._v("V. The Opinion Inverts the Priority of Enumerated and Unenumerated Rights and Appears to Rely on a Reason outside the Constitution.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The opinion’s treatment of "), _c('em', [_vm._v("Wisconsin v. Yoder")]), _vm._v(" elevates the unenumerated right of parents to control the education of their children above the enumerated right to free exercise of religion. Many of these amici welcome this majority’s recognition of unenumerated rights; others view that recognition with alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But the point here is not the existence of unenumerated rights. Instead, the point is the relative status of enumerated and unenumerated rights. If the "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("Court feels free to enforce the unenumerated rights it likes, and to strip all independent meaning from the enumerated rights it does not like, it is hard to see how the existence of a written Constitution affects its decisions. What is the point of enumerating certain rights at all, if not to ensure that at least those rights get enforced?")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("Amici cannot know the Court’s reasons for this inversion of traditional approaches to constitutional interpretation. But we fear that the reason is revealed in the penultimate paragraph, when the opinion says that harm to religious minorities “must be preferred to a system … in which judges weigh the social importance of all laws against the centrality of all religious beliefs.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-56",
      "id": "foot_56"
    }
  }, [_c('sup', [_vm._v("56")])]), _vm._v(" Decisions in free exercise cases are sometimes hard, and it appears to be the majority’s judgment that these cases are not appropriate for judiciary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If this is the Court’s motivation, we believe the Court has erred. The Free Exercise Clause is not just a speech clause, and it is not just an equality clause. It is an express substantive protection for certain conduct, for religious "), _c('em', [_vm._v("exercise.")]), _vm._v(" The Court cannot simply say that such a clause is inconsistent with its conception of the judicial role. The judicial role is defined by the Constitution; the Constitution is not defined by changing conceptions of the judicial role. To refuse to enforce rights that are expressly in the Constitution is as mistaken as enforcing rights that are not in the Constitution.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-12"
    }
  }, [_c('strong', [_c('em', [_vm._v("VI. Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The opinion in this case has momentous consequences for all religions, and especially for religious minorities. Such a momentous decision should not be taken without notice and hearing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court should vacate its opinion in this case and restore the case to the docket for full briefing and argument.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-19"
    }
  }, [_c('strong', [_vm._v("Postscript: The Proposed Statutory Solution")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Bipartisan sponsors have introduced legislation to correct the error in "), _c('em', [_vm._v("Smith.")]), _c('a', {
    attrs: {
      "href": "#/#foot-57",
      "id": "foot_57"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" Known as the Religious Freedom Restoration Act of 1991, the bill "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("would create a federal statutory right to religious exercise. The bill would work one way for state and local laws, and a different way for federal laws, but it would apply the same substantive standards to all levels of government.")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With respect to state and local governments, the bill would be enacted pursuant to § 5 of the Fourteenth Amendment, which authorizes Congress to enforce the amendment by appropriate legislation. The First Amendment’s Free Exercise Clause is applied to the states by the Fourteenth Amendment, so an act to enforce the Free Exercise Clause is an act to enforce the Fourteenth Amendment.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("Under its § 5 power, Congress can enact rules that support constitutional rights, or assist in their enjoyment. Thus, Congress can provide greater protection than the Constitution provides of its own force as interpreted by the Supreme Court.")]), _c('a', {
    attrs: {
      "href": "#/#foot-58",
      "id": "foot_58"
    }
  }, [_c('sup', [_vm._v("58")])]), _vm._v(" The proposed legislation would provide that no state or local government may restrict religious practice, except by facially neutral laws that serve a compelling governmental interest by the least restrictive means. This would not change the Court’s interpretation of the Free Exercise Clause, but it would provide a federal statutory right related to and in aid of more limited rights under the Free Exercise Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With respect to the federal government, Congress can do two things. The proposed bill would subject all existing federal legislation to the same standard applied to the states. That is, no existing federal law could be applied to restrict religious practice, unless the law was facially neutral and served a compelling governmental interest by the least restrictive means. Second, Congress can create a rule of construction with respect to future federal statutes. The bill would provide that future laws should not be construed to restrict religious practice, unless a neutral application to religious practice is the least restrictive means to serve a compelling interest, or unless the future law expressly refers to the Religious Freedom Restoration Act and enacts a different standard. The model here is the Anti-Injunction Act,"), _c('a', {
    attrs: {
      "href": "#/#foot-59",
      "id": "foot_59"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" which provides that no federal court may enjoin pending state litigation, except where expressly authorized by statute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Religious Freedom Restoration Act would enact the principle of exemptions for conscience subject to the compelling interest test. It does not undertake to resolve specific disputes about exemption for specific religious practices. This across-the-board approach has at least two virtues. First, it treats all religions equally, large and small, popular and unpopular. Individual exemptions for particular religious practices would inevitably result in "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("large and well-connected faiths being treated much better than small and uninfluential faiths.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, across-the-board legislation solves most of the problem in one legislative enactment. Exemptions for particular religious practices would have to be enacted one at a time, in statute after statute, at every level of government. The repetitive religious lobbying required to obtain such exemptions one at a time would divert effort from the churches’ religious mission, and it would further entangle the churches in politics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The across-the-board approach avoids these problems, but it is more vulnerable to hostile judicial interpretation. Judges who were too quick to find compelling interests under the Constitution may be equally quick to find compelling interests under the statute. But the judges who eviscerated the Free Exercise Clause said they were deferring to the legislative will. The Religious Freedom Restoration Act would be a clear expression of legislative will that religious practice should be protected from all but the most essential regulation. Perhaps the judges will defer to that expression of legislative will as well.")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#foot_1",
      "id": "foot-1"
    }
  }, [_vm._v("1")]), _vm._v(". 494 U.S. 872 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_2",
      "id": "foot-2"
    }
  }, [_vm._v("2")]), _vm._v(". Editor’s Note: The author of this article was one of the signers, in his capacity as Counsel for the National Council of Churches. Other law professors who signed the petition included Frank S. Alexander, John S. Baker, Charles W. Barrow, William W. Bassett, Patrick L. Baude, Harold J. Berman, Howard Bromberg, Lynn Robert Buzzard, Angela C. Carmella, Erwin Chemerinsky, David M. Cobin, William Cohen, Daniel D. Conkle, Joseph L. Daly, George W. Dent, Robert A. Destro, C. Thomas Dienes, Robert F. Drinan, W. Cole Durham, Carl H. Esbeck, Edward McGlynn Gaffney, Marc Galanter, John K. Garvey, Frederick Mark Gedicks, Donald Gjerdingen, Kent Greenawalt, David W. Guinn, Gerald Gunther, Lynne Henderson, Allan Ides, Stanley Ingber, Phillip E. Johnson, Edward J. Larson, Rosalie Levinson, Sanford Levinson, Karl Manhein, John H. Mansfield, Christopher N. May, Michael W. McConnell, Judith A. McMorrow, James M. O’Fallon, Stephen L. Pepper, Michael John Perry, Lucas A. Powe, Norman Redlich, Charles E. Rice, Lauren Robel, Michael Scherschligt, Margaret Gay Stewart, Richard Stith, Ruti G. Teitel, Laurence H. Tribe, and Howard Vogel.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_3",
      "id": "foot-3"
    }
  }, [_vm._v("3")]), _vm._v(". Editor’s Note: Matters of religious liberty often engender controversy even among various religious organizations, with profoundly differing religious traditions and convictions, and among various organizations devoted to the protection of civil liberties, with their differing political agendas. The swiftness with which a very wide spectrum of religious communities and civil liberties organizations joined together in the petition for rehearing in the "), _c('em', [_vm._v("Smith")]), _vm._v(" case is itself a remarkable sign that the Court had strayed far from the common perception of the duty of the judiciary to protect religious liberty. Signers of the petition for rehearing included the Counsel of the following religious and civil liberties organizations: the American Civil Liberties Foundation, the American Friends Service Committee, the American Jewish Committee, the American Jewish Congress, Americans United for Separation of Church and State, the Baptist Joint Committee for Public Affairs, the Catholic League for Religious and Civil Rights, the Center for Law and Religious Freedom of the Christian Legal Society, the Evangelical Lutheran Church in America, the General Conference of Seventh-day Adventists, the Lutheran Church-Missouri Synod, the National Association of Evangelicals, the National Council of Churches of Christ in the USA, the National Jewish Community Relations Advisory Council, People for the American Way, the Stated Clerk of the General Assembly of the Presbyterian Church (U.S.A.), the Unitarian Universalist Association, the Williamsburg Charter Foundation, and the Worldwide Church of God. Two prominent litigators who appeared often on the opposite sides of many church-state cases in the past two decades, William Bentley Ball and Leo Pfeffer, both signed the petition for rehearing. The Court denied the petition on June 4, 1990. 496 U.S. 913.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_4",
      "id": "foot-4"
    }
  }, [_vm._v("4")]), _vm._v(". See R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TERN,")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UGENE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RESSMAN, AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TEPHEN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPIRO,")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UPREME")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURT")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RACTICE")]), _vm._v(" § 15.8 at 631 (Bureau of National Affairs, 6th ed. 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_5",
      "id": "foot-5"
    }
  }, [_vm._v("5")]), _vm._v(". Editor’s Note: "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("The Remnants of Free Exercise,")]), _vm._v(" 1990 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1; Michael McConnell, "), _c('em', [_vm._v("Free Exercise Revisionism and the Smith Decision,")]), _vm._v(" 57 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1109 (1990); James D. Gordon, F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XERCISE ON THE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUNTAIN")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OP")]), _vm._v(", 79 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 91 (1991); and see Edward McGlynn Gaffney, Douglas Laycock, and Michael W. McConnell, "), _c('em', [_vm._v("An Open Letter on Religious Freedom,")]), _vm._v(" 11 F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HINGS")]), _vm._v(" 44 (March 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_6",
      "id": "foot-6"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Patterson v. McLean Credit Union, 485 U.S. 617 (1988); Garcia v. San Antonio Metropolitan Transit Authority, 468 U.S. 1213 (1984); Illinois v. Gates, 459 U.S. 1028 (1982); Brown v. Bd. of Educ., 347 U.S. 483, 495–96 (1954); Brown v. Bd. of Educ., 345 U.S. 972 (1953).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_7",
      "id": "foot-7"
    }
  }, [_vm._v("7")]), _vm._v(". Michael W. McConnell, "), _c('em', [_vm._v("The Origins and Historical Understanding of Free Exercise of Religion,")]), _vm._v(" 103 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1409, 1466–73 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_8",
      "id": "foot-8"
    }
  }, [_vm._v("8")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 1443–44, 1473.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_9",
      "id": "foot-9"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 1461–62.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_10",
      "id": "foot-10"
    }
  }, [_vm._v("10")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 1453.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_11",
      "id": "foot-11"
    }
  }, [_vm._v("11")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 1435–55, 1473–78.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_12",
      "id": "foot-12"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_13",
      "id": "foot-13"
    }
  }, [_vm._v("13")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_14",
      "id": "foot-14"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Citizen Publishing Co. v. United States, 394 U.S. 131 (1969) (upholding application of antitrust laws to commercial press); Minneapolis Star & Tribune Co. v. Minnesota Commissioner of Revenue, 460 U.S. 575 (1983) (stating that commercial media corporation must pay generally applicable taxes).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_15",
      "id": "foot-15"
    }
  }, [_vm._v("15")]), _vm._v(". Brown v. Socialist Workers ’74 Campaign Comm. (Ohio), 459 U.S. 87 (1982); NAACP v. Alabama, 357 U.S. 449 (1958).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_16",
      "id": "foot-16"
    }
  }, [_vm._v("16")]), _vm._v(". Hustler v. Falwell, 458 U.S. 46 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_17",
      "id": "foot-17"
    }
  }, [_vm._v("17")]), _vm._v(". Smith, 494 U.S. at 886–87.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_18",
      "id": "foot-18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 887.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_19",
      "id": "foot-19"
    }
  }, [_vm._v("19")]), _vm._v(". Osborne v. Ohio, 495 U.S. 103 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_20",
      "id": "foot-20"
    }
  }, [_vm._v("20")]), _vm._v(". Young v. Am. Mini Theaters, 427 U.S. 50, 61 (1976) (“there is surely a less vital interest in the uninhibited exhibition of material that is on the borderline between pornography and artistic expression than in the free dissemination of ideas of political and social significance”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_21",
      "id": "foot-21"
    }
  }, [_vm._v("21")]), _vm._v(". 374 U.S. 398 (1963).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_22",
      "id": "foot-22"
    }
  }, [_vm._v("22")]), _vm._v(". 310 U.S. 586 (1940).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_23",
      "id": "foot-23"
    }
  }, [_vm._v("23")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETER")]), _vm._v(" H. I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RONS, THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURAGE OF")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEIR")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONVICTIONS")]), _vm._v(" 22–35 (Free Press, 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_24",
      "id": "foot-24"
    }
  }, [_vm._v("24")]), _vm._v(". 319 U.S. 624 (1943).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_25",
      "id": "foot-25"
    }
  }, [_vm._v("25")]), _vm._v(". 476 U.S. 693 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_26",
      "id": "foot-26"
    }
  }, [_vm._v("26")]), _vm._v(". 480 U.S. 136, 141 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_27",
      "id": "foot-27"
    }
  }, [_vm._v("27")]), _vm._v(". 455 U.S. 252 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_28",
      "id": "foot-28"
    }
  }, [_vm._v("28")]), _vm._v(". 406 U.S. 205 (1972).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_29",
      "id": "foot-29"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 216.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_30",
      "id": "foot-30"
    }
  }, [_vm._v("30")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 235.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_31",
      "id": "foot-31"
    }
  }, [_vm._v("31")]), _vm._v(". Edwards v. Aguillard, 482 U.S. 578, 617 (Scalia, J., joined by Rehnquist, C.J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_32",
      "id": "foot-32"
    }
  }, [_vm._v("32")]), _vm._v(". 485 U.S. 439 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_33",
      "id": "foot-33"
    }
  }, [_vm._v("33")]), _vm._v(". 476 U.S. 693 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_34",
      "id": "foot-34"
    }
  }, [_vm._v("34")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 883, citing United States v. Lee, 455 U.S. 252 (1982), and Gillette v. United States, 401 U.S. 437 (1971). The Court might have added to this list "), _c('em', [_vm._v("Bob Jones University v. United States,")]), _vm._v(" 461 U.S. 574 (1983), which also scrutinized a facially neutral law under the compelling interest test.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_35",
      "id": "foot-35"
    }
  }, [_vm._v("35")]), _vm._v(". 475 U.S. 503 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_36",
      "id": "foot-36"
    }
  }, [_vm._v("36")]), _vm._v(". 482 U.S. 342 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_37",
      "id": "foot-37"
    }
  }, [_vm._v("37")]), _vm._v(". 485 U.S. 439 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_38",
      "id": "foot-38"
    }
  }, [_vm._v("38")]), _vm._v(". Kahane v. Carlson, 527 F.2d 492 (2d Cir. 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_39",
      "id": "foot-39"
    }
  }, [_vm._v("39")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 881–82.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_40",
      "id": "foot-40"
    }
  }, [_vm._v("40")]), _vm._v(". S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IDNEY")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OOK,")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARADOXES OF")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOM")]), _vm._v(" 23 (California, 1962).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_41",
      "id": "foot-41"
    }
  }, [_vm._v("41")]), _vm._v(". 483 F. Supp. 266 (N.D. Iowa 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_42",
      "id": "foot-42"
    }
  }, [_vm._v("42")]), _vm._v(". 477 U.S. 619 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_43",
      "id": "foot-43"
    }
  }, [_vm._v("43")]), _vm._v(". Daniel Abuhoff, Comment, "), _c('em', [_vm._v("Title VII and the Appointment of Women Clergy: A Statutory and Constitutional Quagmire,")]), _vm._v(" 13 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". J.L. & S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OC.")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROBS")]), _vm._v(". 257 (1977).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_44",
      "id": "foot-44"
    }
  }, [_vm._v("44")]), _vm._v(". 22 Fair Empl. Prac. Cases 762 (Cal. Super. Ct. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_45",
      "id": "foot-45"
    }
  }, [_vm._v("45")]), _vm._v(". 536 A.2d 1 (D.C. App. 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_46",
      "id": "foot-46"
    }
  }, [_vm._v("46")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 887 n.4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_47",
      "id": "foot-47"
    }
  }, [_vm._v("47")]), _vm._v(". 9 Religious Freedom Rptr. 343 (Super. Ct. Suffolk County, Mass., Oct. 11, 1989), "), _c('em', [_vm._v("aff’d on state-law grounds,")]), _vm._v(" 564 N.E.2d 571 (Mass. 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_48",
      "id": "foot-48"
    }
  }, [_vm._v("48")]), _vm._v(". 511 F. Supp. 613 (N.D. Tex. 1981), "), _c('em', [_vm._v("aff’d,")]), _vm._v(" 670 F.2d 46 (5th Cir. 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_49",
      "id": "foot-49"
    }
  }, [_vm._v("49")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("A Survey of Religious Liberty in the United States,")]), _vm._v(" 47 O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIO")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". L.J. 409, 416–19, 438–39 (1986) (text at notes 37–70, 173–79).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_50",
      "id": "foot-50"
    }
  }, [_vm._v("50")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Thomas v. Review Bd., 450 U.S. 707, 717 (1981); Wisconsin v. Yoder, 406 U.S. 205, 220 (1972); Lemon v. Kurtzman, 403 U.S. 602, 612 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_51",
      "id": "foot-51"
    }
  }, [_vm._v("51")]), _vm._v(". For careful analysis of the neutrality of exemptions, see Michael W. McConnell & Richard A. Posner, "), _c('em', [_vm._v("An Economic Approach to Issues of Religious Freedom,")]), _vm._v(" 56 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 32–54 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_52",
      "id": "foot-52"
    }
  }, [_vm._v("52")]), _vm._v(". Where this is not true — where religious practice coincides with self-interest, as in conscientious objection to military service — the calculus of neutrality may be different, and the Court has taken that into account. "), _c('em', [_vm._v("See")]), _vm._v(" Gillette v. United States, 401 U.S. 437 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_53",
      "id": "foot-53"
    }
  }, [_vm._v("53")]), _vm._v(". Smith, 494 U.S. at 890.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_54",
      "id": "foot-54"
    }
  }, [_vm._v("54")]), _vm._v(". Carolene Products v. United States, 304 U.S. 144, 152 n.4 (1938).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_55",
      "id": "foot-55"
    }
  }, [_vm._v("55")]), _vm._v(". County of Allegheny v. Am. Civil Liberties Union, 492 U.S. 573, 655 (1989) (Kennedy, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_56",
      "id": "foot-56"
    }
  }, [_vm._v("56")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 890.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_57",
      "id": "foot-57"
    }
  }, [_vm._v("57")]), _vm._v(". HR 5377 (101st Cong. 2d Sess.). Similar legislation will be introduced in the 102nd Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_58",
      "id": "foot-58"
    }
  }, [_vm._v("58")]), _vm._v(". Katzenbach v. Morgan, 384 U.S. 641 (1966).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_59",
      "id": "foot-59"
    }
  }, [_vm._v("59")]), _vm._v(". 42 U.S.C. § 2283 (1988).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a45f65a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/015_Chapter02-a.vue
// module id = 99
// module chunks = 0